"use client";

import { c as _c } from "react/compiler-runtime";
import { Image as ImageIcon } from "@mui/icons-material";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Text, TextColor, TextSize } from "../../components";
import { extractSize } from "../../utils";
// Images
import Image1 from "./1.jpg";
import Image2 from "./2.jpg";
// Reusable components
const ImagePlaceholder = t0 => {
  const $ = _c(7);
  const {
    width,
    height,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `bg-gray-100 flex items-center justify-center ${className}`;
  let t3;
  if ($[0] !== height || $[1] !== width) {
    t3 = {
      width,
      height
    };
    $[0] = height;
    $[1] = width;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-center"><ImageIcon className="w-8 h-8 text-gray-400" /><p className="mt-1 text-xs text-gray-500">Brak zdjęcia</p></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3) {
    t5 = <div className={t2} style={t3}>{t4}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
const VariantImagePlaceholder = t0 => {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `w-[30px] h-[45px] bg-gray-100 flex items-center justify-center rounded-full ${className}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 002 2z" /></svg>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <div className={t2}>{t3}</div>;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
};
const ProductMiniature = t0 => {
  const $ = _c(106);
  const {
    product,
    isHomePage: t1,
    onClick
  } = t0;
  const isHomePage = t1 === undefined ? false : t1;
  const [selectedCombination, setSelectedCombination] = useState(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [availableCombinations, setAvailableCombinations] = useState(t2);
  const [hoveredCombination, setHoveredCombination] = useState(null);
  const [isMainImageHovered, setIsMainImageHovered] = useState(false);
  const [imageError, setImageError] = useState(false);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = new Set();
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [variantImageErrors, setVariantImageErrors] = useState(t3);
  let t4;
  if ($[2] !== product.combinations || $[3] !== product.idProductAttribute) {
    t4 = () => {
      if (product.combinations?.values) {
        const combinations = product.combinations.values;
        const defaultCombination = combinations.find(combo_0 => combo_0.idProductAttribute === product.idProductAttribute?.toString()) || combinations.find(_temp) || combinations[0];
        setSelectedCombination(defaultCombination || null);
        setAvailableCombinations(combinations);
      }
    };
    $[2] = product.combinations;
    $[3] = product.idProductAttribute;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== product) {
    t5 = [product];
    $[5] = product;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== product.url) {
    t6 = () => {
      const url = product.url.replace("/odziez-dla-dziewczynek", "").replace("/odziez-dla-chlopcow", "");
      return `/${url}`;
    };
    $[7] = product.url;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const getProductUrl = t6;
  const processImageUrl = _temp2;
  let t7;
  if ($[9] !== hoveredCombination || $[10] !== isMainImageHovered || $[11] !== product.cover || $[12] !== selectedCombination) {
    t7 = () => {
      const currentCombination = hoveredCombination || selectedCombination;
      let imageUrl;
      if (isMainImageHovered && currentCombination?.images?.[0]?.url) {
        imageUrl = currentCombination.images[0].url;
      } else {
        if (currentCombination?.cover?.url) {
          imageUrl = currentCombination.cover.url;
        } else {
          if (product.cover?.url) {
            imageUrl = product.cover.url;
          } else {
            return Image1;
          }
        }
      }
      return processImageUrl(imageUrl);
    };
    $[9] = hoveredCombination;
    $[10] = isMainImageHovered;
    $[11] = product.cover;
    $[12] = selectedCombination;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const getImageSrc = t7;
  let t8;
  if ($[14] !== hoveredCombination || $[15] !== product.images || $[16] !== selectedCombination) {
    t8 = () => {
      const currentCombination_0 = hoveredCombination || selectedCombination;
      if (currentCombination_0?.images && currentCombination_0.images.length > 1 && currentCombination_0.images[1]?.url) {
        return processImageUrl(currentCombination_0.images[1].url);
      }
      if (product.images && product.images.length > 1 && product.images[1]?.url) {
        return processImageUrl(product.images[1].url);
      }
      return Image2;
    };
    $[14] = hoveredCombination;
    $[15] = product.images;
    $[16] = selectedCombination;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const getSecondImageSrc = t8;
  let t9;
  if ($[18] !== availableCombinations || $[19] !== selectedCombination) {
    t9 = () => {
      if (!availableCombinations.length) {
        return [];
      }
      const currentColor = selectedCombination?.attributes?.Kolor;
      const colorMap = new Map();
      if (selectedCombination && currentColor) {
        colorMap.set(currentColor, selectedCombination);
      }
      availableCombinations.forEach(combo_1 => {
        const color = combo_1.attributes?.Kolor;
        if (color && !colorMap.has(color)) {
          colorMap.set(color, combo_1);
        }
      });
      return Array.from(colorMap.values());
    };
    $[18] = availableCombinations;
    $[19] = selectedCombination;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const getColorVariants = t9;
  let t10;
  if ($[21] !== availableCombinations || $[22] !== selectedCombination?.attributes?.Kolor) {
    t10 = () => {
      if (!availableCombinations.length) {
        return false;
      }
      const currentColor_0 = selectedCombination?.attributes?.Kolor;
      const sizesInCurrentColor = availableCombinations.filter(combo_2 => combo_2.attributes?.Kolor === currentColor_0 && combo_2.quantity > 0).map(_temp3).filter(Boolean);
      return sizesInCurrentColor.length > 0;
    };
    $[21] = availableCombinations;
    $[22] = selectedCombination?.attributes?.Kolor;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const hasSizesToDisplay = t10;
  let t11;
  if ($[24] !== availableCombinations) {
    t11 = combination => {
      const color_0 = combination.attributes?.Kolor;
      if (!color_0) {
        return [];
      }
      return availableCombinations.filter(combo_4 => combo_4.attributes?.Kolor === color_0 && combo_4.quantity > 0).map(_temp4).filter(Boolean);
    };
    $[24] = availableCombinations;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const getAvailableSizesForCombination = t11;
  let t12;
  if ($[26] !== availableCombinations || $[27] !== selectedCombination?.attributes?.Kolor) {
    t12 = () => {
      if (!availableCombinations.length) {
        return [];
      }
      const currentColor_1 = selectedCombination?.attributes?.Kolor;
      return availableCombinations.filter(combo_6 => combo_6.attributes?.Kolor === currentColor_1 && combo_6.quantity > 0).map(_temp5).filter(Boolean);
    };
    $[26] = availableCombinations;
    $[27] = selectedCombination?.attributes?.Kolor;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const getCurrentColorSizes = t12;
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = combination_0 => {
      setHoveredCombination(combination_0);
    };
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const handleCombinationHover = t13;
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => {
      setHoveredCombination(null);
    };
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const handleCombinationLeave = t14;
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => {
      setIsMainImageHovered(true);
    };
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const handleMainImageHover = t15;
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => {
      setIsMainImageHovered(false);
    };
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const handleMainImageLeave = t16;
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => {
      setImageError(true);
    };
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  const handleImageError = t17;
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = combinationId => {
      setVariantImageErrors(prev => new Set(prev).add(combinationId));
    };
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  const handleVariantImageError = t18;
  let t19;
  if ($[35] !== getImageSrc || $[36] !== getSecondImageSrc || $[37] !== hoveredCombination || $[38] !== imageError || $[39] !== product.cover?.large?.url || $[40] !== product.cover?.url || $[41] !== product.name || $[42] !== selectedCombination) {
    t19 = () => {
      if (imageError || !selectedCombination?.cover?.url && !product.cover?.url) {
        return <ImagePlaceholder width="100%" height="430px" className="w-full h-auto object-cover transition-transform duration-300 ease-in-out hover:scale-105" />;
      }
      const currentCombination_1 = hoveredCombination || selectedCombination;
      const altText = currentCombination_1?.cover?.legend || product.name;
      return <Image src={getImageSrc()} alt={altText} width={300} height={430} className="w-full h-auto object-cover transition-transform duration-300 ease-in-out" data-original-src={getImageSrc()} data-full-size-image-url={currentCombination_1?.cover?.large?.url || product.cover?.large?.url} data-second-image={getSecondImageSrc()} data-original-second-image={getSecondImageSrc()} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw" onError={handleImageError} />;
    };
    $[35] = getImageSrc;
    $[36] = getSecondImageSrc;
    $[37] = hoveredCombination;
    $[38] = imageError;
    $[39] = product.cover?.large?.url;
    $[40] = product.cover?.url;
    $[41] = product.name;
    $[42] = selectedCombination;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  const renderMainImage = t19;
  let t20;
  if ($[44] !== getColorVariants || $[45] !== product.name || $[46] !== selectedCombination || $[47] !== variantImageErrors) {
    t20 = () => {
      const colorVariants = getColorVariants();
      if (!colorVariants.length || colorVariants.length <= 1) {
        return null;
      }
      return <div className="flex justify-center gap-2 mb-2.5">{colorVariants.map(combination_1 => {
          const colorName = combination_1.attributes?.Kolor;
          const combinationId_0 = combination_1.idProductAttribute;
          const isCurrentCombination = combination_1 === selectedCombination;
          return <div key={combinationId_0} className="no-underline" title={`${product.name} : Kolor - ${colorName}`} onMouseEnter={() => handleCombinationHover(combination_1)} onMouseLeave={handleCombinationLeave}>{variantImageErrors.has(combinationId_0) || !combination_1.cover?.url ? <VariantImagePlaceholder className={`cursor-pointer transition-all duration-300 ${isCurrentCombination ? "border-gray-500 border-t-2" : "hover:border-gray-400"}`} /> : <Image src={processImageUrl(combination_1.cover.url)} alt={colorName || ""} width={30} height={45} className={`w-[30px] h-[45px] cursor-pointer transition-all duration-300 ${isCurrentCombination ? "border-t-2 border-gray-500" : "border-t-2 border-transparent hover:border-gray-500"}`} data-combination-id={combinationId_0} onError={() => handleVariantImageError(combinationId_0)} />}</div>;
        })}</div>;
    };
    $[44] = getColorVariants;
    $[45] = product.name;
    $[46] = selectedCombination;
    $[47] = variantImageErrors;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  const renderColorVariants = t20;
  let t21;
  if ($[49] !== getAvailableSizesForCombination || $[50] !== getColorVariants || $[51] !== getCurrentColorSizes || $[52] !== hasSizesToDisplay || $[53] !== hoveredCombination) {
    t21 = () => {
      const colorVariants_0 = getColorVariants();
      const hasSizes = hasSizesToDisplay();
      if (colorVariants_0.length > 0) {
        const currentSizes = getCurrentColorSizes();
        const hoveredVariant = colorVariants_0.find(combination_2 => hoveredCombination === combination_2);
        if (hoveredVariant) {
          const availableSizes = getAvailableSizesForCombination(hoveredVariant);
          return <div className="absolute bottom-0 w-full left-1/2 transform -translate-x-1/2 font-nunito font-semibold text-xs text-gray-500"><div className="text-center max-w-[90%] mx-auto whitespace-nowrap overflow-hidden text-ellipsis">{availableSizes.length > 0 ? availableSizes.map((size, sizeIndex) => <span key={sizeIndex}>{size}{sizeIndex < availableSizes.length - 1 ? " " : ""}</span>) : <span>Brak dostępnych rozmiarów</span>}</div></div>;
        } else {
          return <div className="absolute bottom-0 w-full left-1/2 transform -translate-x-1/2 font-nunito font-semibold text-xs text-gray-500"><div className="text-center max-w-[90%] mx-auto whitespace-nowrap overflow-hidden text-ellipsis">{currentSizes.map((size_0, sizeIndex_0) => <span key={sizeIndex_0}>{size_0}{sizeIndex_0 < currentSizes.length - 1 ? " " : ""}</span>)}</div></div>;
        }
      }
      if (hasSizes) {
        const currentSizes_0 = getCurrentColorSizes();
        return <div className="absolute bottom-0 w-full left-1/2 transform -translate-x-1/2 font-nunito font-semibold text-xs text-gray-500"><div className="text-center max-w-[90%] mx-auto whitespace-nowrap overflow-hidden text-ellipsis">{currentSizes_0.map((size_1, sizeIndex_1) => <span key={sizeIndex_1}>{size_1}{sizeIndex_1 < currentSizes_0.length - 1 ? " " : ""}</span>)}</div></div>;
      }
      return null;
    };
    $[49] = getAvailableSizesForCombination;
    $[50] = getColorVariants;
    $[51] = getCurrentColorSizes;
    $[52] = hasSizesToDisplay;
    $[53] = hoveredCombination;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  const renderVariantSizes = t21;
  let t22;
  if ($[55] !== product.labels) {
    t22 = () => {
      if (!product.labels?.length) {
        return null;
      }
      return <ul className="absolute top-[5px] left-[5px] z-8 list-none m-0 p-0">{product.labels.map(_temp6)}</ul>;
    };
    $[55] = product.labels;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  const renderProductLabels = t22;
  let t23;
  if ($[57] !== getColorVariants || $[58] !== getProductUrl || $[59] !== hasSizesToDisplay || $[60] !== hoveredCombination || $[61] !== isHomePage || $[62] !== onClick || $[63] !== product.categoryName || $[64] !== product.description || $[65] !== product.discountPrice || $[66] !== product.hasDiscount || $[67] !== product.lowestPrice || $[68] !== product.name || $[69] !== product.price || $[70] !== product.regularPrice || $[71] !== product.showPrice || $[72] !== selectedCombination) {
    t23 = () => {
      const colorVariants_1 = getColorVariants();
      const hasSizes_0 = hasSizesToDisplay();
      const hasNoVariants = !colorVariants_1.length && !hasSizes_0;
      const currentCombination_2 = hoveredCombination || selectedCombination;
      const getCurrentDescription = () => {
        if (currentCombination_2?.description) {
          return currentCombination_2.description;
        }
        return product.description;
      };
      const cleanDescription = _temp7;
      const ProductTitle = t24 => {
        const {
          children,
          className
        } = t24;
        return <Link href={getProductUrl()} target="_blank" className="text-gray-800 no-underline hover:text-gray-600 transition-colors duration-200" onClick={onClick}><span className={className}>{children}</span></Link>;
      };
      return <div className={`
          highlighted-informations
          bg-transparent 
          text-left 
          w-full 
          h-[80px] 
          transition-all 
          duration-300
          ${hasNoVariants ? "no-variants" : ""}
        `}><div className="highlighted-description h-[80px] bg-white px-1.5 py-1 relative z-20">{isHomePage ? <h3 className="font-extrabold text-sm text-gray-800 leading-4 m-0 text-ellipsis overflow-hidden whitespace-nowrap h-5 block"><ProductTitle className="text-ellipsis overflow-hidden whitespace-nowrap block">{product.categoryName || product.name}</ProductTitle></h3> : <h2 className="font-extrabold text-sm text-gray-800 leading-4 m-0 text-ellipsis overflow-hidden whitespace-nowrap h-5 block"><ProductTitle className="text-ellipsis overflow-hidden whitespace-nowrap block">{product.categoryName || product.name}</ProductTitle></h2>}<p className={"\n              miniature-description \n              text-sm \n              pr-1.5 \n              text-gray-600 \n              leading-4\n              text-ellipsis\n              overflow-hidden\n              whitespace-nowrap\n              h-4\n              mb-0\n              block\n            "}>{cleanDescription(getCurrentDescription())}</p>{product.showPrice && <div className="product-price-and-shipping w-full pt-1">{product.hasDiscount ? <div className="flex flex-col"><div className="flex items-center gap-2"><span className={"\n                      regular-price \n                      text-gray-800 \n                      line-through \n                      text-xs\n                    "}>{product.regularPrice}</span><span className={"\n                      price \n                      font-nunito \n                      font-extrabold \n                      text-base \n                      text-red-500\n                    "}>{product.discountPrice}</span></div>{product.lowestPrice && <Text text={`Najniższa cena z 30 dni przed obniżką: ${product.lowestPrice}`} fontSize={TextSize.XXS} color={TextColor.GRAYSCALE_300} />}</div> : <span className={"\n                    price \n                    without-reduction \n                    font-nunito \n                    font-extrabold \n                    text-xs \n                    text-gray-800\n                  "}>{product.price}</span>}</div>}</div></div>;
    };
    $[57] = getColorVariants;
    $[58] = getProductUrl;
    $[59] = hasSizesToDisplay;
    $[60] = hoveredCombination;
    $[61] = isHomePage;
    $[62] = onClick;
    $[63] = product.categoryName;
    $[64] = product.description;
    $[65] = product.discountPrice;
    $[66] = product.hasDiscount;
    $[67] = product.lowestPrice;
    $[68] = product.name;
    $[69] = product.price;
    $[70] = product.regularPrice;
    $[71] = product.showPrice;
    $[72] = selectedCombination;
    $[73] = t23;
  } else {
    t23 = $[73];
  }
  const renderProductInfo = t23;
  if ((product.combinations?.values?.length || 0) === 0) {
    return null;
  }
  const t24 = product.idProduct;
  const t25 = selectedCombination?.idProductAttribute;
  let t26;
  if ($[74] !== getColorVariants) {
    t26 = getColorVariants();
    $[74] = getColorVariants;
    $[75] = t26;
  } else {
    t26 = $[75];
  }
  const t27 = getProductUrl();
  const t28 = getProductUrl();
  const t29 = selectedCombination?.idProductAttribute;
  let t30;
  if ($[76] !== renderMainImage) {
    t30 = renderMainImage();
    $[76] = renderMainImage;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  let t31;
  if ($[78] !== t29 || $[79] !== t30) {
    t31 = <div className="relative overflow-hidden" data-combination-id={t29} onMouseEnter={handleMainImageHover} onMouseLeave={handleMainImageLeave}>{t30}</div>;
    $[78] = t29;
    $[79] = t30;
    $[80] = t31;
  } else {
    t31 = $[80];
  }
  let t32;
  if ($[81] !== onClick || $[82] !== t27 || $[83] !== t28 || $[84] !== t31) {
    t32 = <Link href={t27} data-original-href={t28} className="block no-underline" onClick={onClick}>{t31}</Link>;
    $[81] = onClick;
    $[82] = t27;
    $[83] = t28;
    $[84] = t31;
    $[85] = t32;
  } else {
    t32 = $[85];
  }
  let t33;
  if ($[86] !== renderProductLabels) {
    t33 = renderProductLabels();
    $[86] = renderProductLabels;
    $[87] = t33;
  } else {
    t33 = $[87];
  }
  let t34;
  if ($[88] !== renderColorVariants) {
    t34 = renderColorVariants();
    $[88] = renderColorVariants;
    $[89] = t34;
  } else {
    t34 = $[89];
  }
  let t35;
  if ($[90] !== renderVariantSizes) {
    t35 = renderVariantSizes();
    $[90] = renderVariantSizes;
    $[91] = t35;
  } else {
    t35 = $[91];
  }
  let t36;
  if ($[92] !== t34 || $[93] !== t35) {
    t36 = <div className="text-center h-[80px] relative bg-white"><div className="py-1.5">{t34}{t35}</div></div>;
    $[92] = t34;
    $[93] = t35;
    $[94] = t36;
  } else {
    t36 = $[94];
  }
  let t37;
  if ($[95] !== renderProductInfo) {
    t37 = renderProductInfo();
    $[95] = renderProductInfo;
    $[96] = t37;
  } else {
    t37 = $[96];
  }
  let t38;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <div className="hidden group-hover:block absolute top-0 left-[10%] w-4/5 opacity-25 pointer-events-none" />;
    $[97] = t38;
  } else {
    t38 = $[97];
  }
  let t39;
  if ($[98] !== product.idProduct || $[99] !== t25 || $[100] !== t26 || $[101] !== t32 || $[102] !== t33 || $[103] !== t36 || $[104] !== t37) {
    t39 = <ProductMiniatureWrapper className="product-miniature group" data-id-product={t24} data-id-product-attribute={t25} itemScope={true} itemType="http://schema.org/Product" tabIndex={0} colorVariants={t26}>{t32}{t33}{t36}{t37}{t38}</ProductMiniatureWrapper>;
    $[98] = product.idProduct;
    $[99] = t25;
    $[100] = t26;
    $[101] = t32;
    $[102] = t33;
    $[103] = t36;
    $[104] = t37;
    $[105] = t39;
  } else {
    t39 = $[105];
  }
  return t39;
};
const ProductMiniatureWrapper = styled.article`
  position: relative;
  background-color: white;
  width: 100%;

  .highlighted-informations {
    position: absolute;
    bottom: 0;
    z-index: 10;
    background-color: transparent;
    text-align: left;
    width: 100%;
    transition: all 0.3s ease;

    &.no-variants {
      bottom: 0;
    }
  }

  &:hover,
  &:active,
  &:focus {
    .highlighted-informations {
      bottom: ${({
  colorVariants
}) => colorVariants.length > 1 ? "80px" : "17px"};

      &.no-variants {
        bottom: 17px;
      }
    }
  }
`;
export default ProductMiniature;
function _temp(combo) {
  return combo.quantity > 0;
}
function _temp2(url_0) {
  if (process.env.NODE_ENV === "development") {
    return url_0.replace("http://localhost/prestashop", "https://shop.carry.pl");
  }
  return url_0.replace("carry-prestashop.ulam.tech", "shop.carry.pl");
}
function _temp3(combo_3) {
  return extractSize(combo_3.attributes);
}
function _temp4(combo_5) {
  return extractSize(combo_5.attributes);
}
function _temp5(combo_7) {
  return extractSize(combo_7.attributes);
}
function _temp6(label, index) {
  return <li key={index} className="block w-fit uppercase mb-1.5 py-1 px-2 text-xs font-medium z-10" style={{
    color: label.color,
    backgroundColor: label.bgColor
  }}><Text text={label.title} fontSize={TextSize.XS} /></li>;
}
function _temp7(description) {
  if (!description || description.length === 0) {
    return "";
  }
  return description.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
}